import React from 'react';

type AccountComponentProps = {
  children: JSX.Element;
};

function Account({ children }: AccountComponentProps) {
  return <div className="account__route">{children}</div>;
}

export default Account;
